export interface SignUpModel {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  password: string;
  birthdate: string;
  gender: string;
}
